// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CxsZVEGhgpYCvQ {\n  margin-bottom: 12px;\n}\n.apwKsTFK911Iiv {\n  border-color: var(--ds-border-danger, #EB5A46);\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamTypeSelect": "CxsZVEGhgpYCvQ",
	"error": "apwKsTFK911Iiv"
};
export default ___CSS_LOADER_EXPORT___;
